import { useEffect, useState } from "react";
import useAuth from "../../../hooks/useAuth";

export const useData = () => {
  const [filterData, setFilterData] = useState(null);
  const [filterOptions, setFilterOptions] = useState(null);
  const [filterByDate, setFilterByDate] = useState(null);
  const [flussiData, setFlussiData] = useState([]);
  const [flussiTotalRows, setFlussiTotalRows] = useState(0);
  const [flussiPageNumber, setFlussiPageNumber] = useState(1);
  const [flussiName, setFlussiName] = useState("");
  const [barChartData, setBarChartData] = useState(null);
  const [rcData, setRcData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [loading, setLoading] = useState(true);
  const [isTableChanging, setIsTableChanging] = useState(false);
  const [filtersLoading, setFiltersLoading] = useState(false);
  const [isRemovingFilters, setIsRemovingFilters] = useState(false);
  const [canClearFilters, setCanClearFilters] = useState(false);
  const [idFlusso, setIdFlusso] = useState(null);
  const [isApplyFiltersButtonDisabled, setIsApplyFiltersButtonDisabled] =
    useState(false);
  const { flussiGetList, flussiGetDetails, getData } = useAuth();

  const getFlussi = (pageNumber = 1) => {
    setIsTableChanging(true);
    flussiGetList(5, pageNumber)
      .then((response) => {
        if (response.status === 1) {
          setBarChartData(response?.data?.graphBarData);
          setFlussiTotalRows(response?.data?.totalRows);
          setFlussiData(response?.data?.dataset);
          setIsTableChanging(false);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // Initial fetch for flussi
  useEffect(() => {
    getFlussi(flussiPageNumber);
  }, [flussiPageNumber]);

  // Handle selection and fetch details
  useEffect(() => {
    if (idFlusso) {
      const { flusso, stato } = idFlusso;
      console.log("Flusso selezionato:", flusso, stato);

      setIsTableChanging(true);
      flussiGetDetails(flusso, stato)
        .then((response) => {
          if (response.status === 1) {
            setRcData(response?.data || []);
            setTotalRows(response?.data?.length || 0);
            setIsTableChanging(false);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setRcData([]);
      setTotalRows(0);
    }
  }, [idFlusso]);

  // Fetch filter options
  useEffect(() => {
    getData({ action: "rcAutoGetFilter" }).then((response) => {
      if (response.status === 1) {
        setFilterOptions(response.data);
      }
    });
  }, []);

  // Function that checks if the user has set filters
  const hasFilters = () => {
    if (!filterData) {
      return false;
    }

    return Object.keys(filterData)?.some(
      (key) =>
        filterData[key] !== undefined &&
        filterData[key] !== null &&
        filterData[key] !== "",
    );
  };

  // Handle filter button disabled state
  useEffect(() => {
    setIsApplyFiltersButtonDisabled(!hasFilters());
    setCanClearFilters(hasFilters());
  }, [filterData]);

  // function that changes the table page
  const handleFlussiPageChange = (newPage) => {
    setFlussiPageNumber(newPage + 1);
  };

  // function that changes the rc table page
  const handlePageChange = (newPage) => {
    setPageNumber(newPage + 1);
  };

  // function that changes the rc table rows (size)
  const handlePageSizeChange = (newPageSize) => {
    setRowsPerPage(newPageSize);
    setPageNumber(1);
  };

  // function that handles the get rc list api call with the filter the user has set and in response updates the list
  const handleApplyFilters = () => {
    console.log("Applica filtri - Dati correnti:", filterData);
  };

  // function that handles the get rc list api call when the user removes all filters and in response the list is updated with the initial state
  const handleRemoveFilters = () => {
    console.log("handleRemoveFilters called");
    setFilterData(null);
    setCanClearFilters(false);
    setFilterByDate(null);
  };

  return {
    getFlussi,
    handleFlussiPageChange,
    handlePageChange,
    handlePageSizeChange,
    handleApplyFilters,
    handleRemoveFilters,
    barChartData,
    rcData,
    totalRows,
    loading,
    filtersLoading,
    isApplyFiltersButtonDisabled,
    pageNumber,
    rowsPerPage,
    filterOptions,
    filterData,
    setFilterData,
    setFilterByDate,
    canClearFilters,
    isRemovingFilters,
    flussiData,
    flussiTotalRows,
    flussiPageNumber,
    setIdFlusso,
    idFlusso,
    setFlussiName,
    flussiName,
  };
};
